import { RadioGroup as MuiRadioGroup, FormLabel, FormControl } from '@mui/material';
import type {
  FormControlProps,
  FormLabelProps,
  RadioGroupProps as MuiRadioGroupProps,
} from '@mui/material';
import { Radio, RadioProps } from './Radio';

export type RadioGroupProps = MuiRadioGroupProps & {
  id?: string;
  label?: string;
  name: string;
  formLabelProps?: Omit<FormLabelProps, 'children'>;
  formControlProps?: FormControlProps;
  radios?: RadioProps[];
};

export const RadioGroup = ({
  children,
  label,
  id,
  onChange,
  formLabelProps,
  formControlProps,
  radios,
  ...props
}: RadioGroupProps) => {
  return (
    <FormControl {...formControlProps}>
      {label && (
        <FormLabel {...formLabelProps} id={id}>
          {label}
        </FormLabel>
      )}
      <MuiRadioGroup {...props} onChange={onChange}>
        {radios?.map(radio => <Radio key={radio?.id} {...radio} />)}
        {children}
      </MuiRadioGroup>
    </FormControl>
  );
};
